export var searchFieldPlaceholder = 'Zip Code or Store Number';
export var EDIT_PICKUP_LOCATION_ALERT_MESSAGE;
(function (EDIT_PICKUP_LOCATION_ALERT_MESSAGE) {
    EDIT_PICKUP_LOCATION_ALERT_MESSAGE["ERROR"] = "We cannot find a Home Depot store that meets your search criteria.";
    EDIT_PICKUP_LOCATION_ALERT_MESSAGE["NO_STORES_IN_RANGE"] = "These items are not available in any stores within 100 miles of your search criteria.";
})(EDIT_PICKUP_LOCATION_ALERT_MESSAGE || (EDIT_PICKUP_LOCATION_ALERT_MESSAGE = {}));
